export const SET = '/payment/set';
